import { styled } from '@volkswagen-onehub/components-core';

export const EventBannerWrapper = styled.div`
  img {
    z-index: 0;
  }
    div span {
      z-index: 3;
      position: relative;

      a {
        color: #fff;
        text-decoration: underline;
      }
    }
`;
